import * as React from 'react';
import { connect } from 'react-redux';
import { signUp } from '../../actions/newsletterAction';
import { INewsletterPageData } from '../../interfaces/INewsletter';
import { CheckMarkList } from './components/NewsletterCheckMarkList';
import { NewletterFooter } from './components/NewsletterFooter';
import { Form } from './components/NewsletterForm';
import { IRouterReducer } from '../../reducers/router';
import { IPageDataReducer } from '../../reducers/pageData';

interface StateProps {
    newsletterPage: INewsletterPageData;
    router: IRouterReducer;
    pageData: IPageDataReducer;
}

interface DispatchedProps {
    signUp: Function;
}

type IProps = StateProps & DispatchedProps;

export class NewsletterPageClass extends React.Component<IProps, {}> {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            newsletterHeadline,
            newsletterBenefits,
            newsletterFooterText,
            backgroundImage,
        } = this.props.newsletterPage;
        const backgroundStyle = {
            backgroundImage: `url(${backgroundImage})`,
        };
        const formProps = {
            newsletterHeadline,
            signUp: this.props.signUp,
            pageUrl: this.props.router.path,
            portalId: this.props.pageData.brandConfig.portalId,
        };

        const showBenefits = Boolean(
            newsletterBenefits &&
                newsletterBenefits.length > 0 &&
                newsletterBenefits[0]?.benefit &&
                newsletterBenefits[0]?.benefit.length > 0,
        );
        return (
            <div>
                <div className="newsLetterPage" style={backgroundStyle}>
                    <Form {...formProps} />
                    {showBenefits && (
                        <CheckMarkList
                            benefits={newsletterBenefits}
                            baseStyleClass="checkMarkList"
                        />
                    )}
                </div>
                <NewletterFooter text={newsletterFooterText} />
            </div>
        );
    }
}
const mapStateToProps = (state: StateProps) => ({
    newsletterPage: state.newsletterPage,
    router: state.router,
    pageData: state.pageData,
});

const mapDispatchToProps = { signUp };

export const NewsletterPage = connect<StateProps, DispatchedProps, any>(
    mapStateToProps,
    mapDispatchToProps,
)(NewsletterPageClass);
export default NewsletterPage;
